import common from "./common.json";

export { common };
